import { addMutator } from '@poa/state';

import {
  setDates,
  fetchGeneralProfile,
  fetchGeneralProfileSuccess,
  fetchGeneralProfileFailed,
  fetchGeneralProfiles,
  fetchGeneralProfilesSuccess,
  fetchGeneralProfilesFailed,
  fetchGeneralProfileChildren,
  fetchGeneralProfileChildrenSuccess,
  fetchGeneralProfileChildrenFailed,
  updateGeneralProfileSuccess,
  createTransferSuccess,
  updateTransferSuccess,
  fetchGeneralReportsSuccess
} from './general.actions';


// fetch
addMutator(fetchGeneralProfile, (_, { store }) => {
  store.generalProfile.meta.hasError = false;
  store.generalProfile.is_loading = true;
});

addMutator(fetchGeneralProfileSuccess, ({ data }, { store }) => {
  store.generalProfile.meta.hasError = false;
  store.generalProfile.selectedProfile = data;
  store.generalProfile.is_loading = false;
});

addMutator(fetchGeneralProfileFailed, (_, { store }) => {
  store.generalProfile.meta.hasError = true;
  store.generalProfile.selectedProfile = {};
  store.generalProfile.is_loading = false;
});

addMutator(updateGeneralProfileSuccess, ({ data }, { store, env }) => {
  store.generalProfile.meta.hasError = false;
  store.generalProfile.selectedProfile = data;
});


addMutator(fetchGeneralProfiles, (_, { store }) => {
  store.generalProfile.meta.isLoading = true;
  store.generalProfile.meta.hasError = false;
});

addMutator(fetchGeneralProfilesSuccess, ({ data }, { store }) => {
  store.generalProfile.meta.isLoading = false;
  store.generalProfile.meta.hasError = false;

  if (data.data._meta.page === 1) {
    store.generalProfile.data.replace(data.data.profiles)
  } else {
    store.generalProfile.data.push(...data.data.profiles);
  }

  store.generalProfile.meta.pages = data.data._meta.pages;
  store.generalProfile.meta.currentPage = data.data._meta.page;
  store.generalProfile.meta.totalProfiles = data.data._meta.on_page;

  store.generalProfile.meta.loaded = true;
});

addMutator(fetchGeneralProfilesFailed, (_, { store }) => {
  store.generalProfile.meta.isLoading = false;
  store.generalProfile.meta.hasError = true;
});

addMutator(fetchGeneralProfileChildren, (_, { store }) => {
  store.generalProfile.meta.hasError = false;
});

addMutator(fetchGeneralProfileChildrenSuccess, ({ data, id }, { store }) => {
  store.generalProfile.meta.hasError = false;
  const element = store.generalProfile.data.find(item => item.id === id);

  if (element) {
    element.children.replace(data);
  } else {
    console.log(`Element with id ${id} not found`);
  }
});

addMutator(fetchGeneralProfileChildrenFailed, (_, { store }) => {
  store.generalProfile.meta.hasError = true;
});


addMutator(createTransferSuccess, ({ data }, { store }) => {
  store.generalProfile.meta.hasError = false;
  store.generalProfile.selectedProfile = data;
});

addMutator(updateTransferSuccess, ({ data }, { store }) => {
  store.generalProfile.meta.hasError = false;
  store.generalProfile.selectedProfile = data;
});

addMutator(setDates, ({ startDate, endDate }, { store }) => {
  if (startDate) {
    store.generalProfile.filters.startDate = startDate;
  }

  if (endDate) {
    store.generalProfile.filters.endDate = endDate;
  }
});


addMutator(fetchGeneralReportsSuccess, ({ data }, { store }) => {
  store.generalProfile.reports = data.reports || [];

  if (store.generalProfile.activeReportId === null) {
    store.generalProfile.activeReport = data.reports.length > 0 ? data.reports[0] : {
      id: null,
      name: '',
      instruction: '',
      result: '',
      date_updated: "TODAY",
      date_created: "TODAY"
    };
    store.generalProfile.activeReportId = data.reports.length > 0 ? data.reports[0].id : null;
  } else {
    store.generalProfile.activeReport = data.reports.find(
      report => report.id === store.generalProfile.activeReportId
    ) || {
      id: null,
      name: '',
      instruction: '',
      result: '',
      date_updated: "TODAY",
      date_created: "TODAY"
    };
  }

});